import config from '../config';

import ApiClient from './ApiClient';

const createClient = (path: any) => {
  let client: ApiClient | null = null;
  return () => {
    if (client === null) {
      client = new ApiClient(path);
    }
    return client;
  };
};

// Main App
const mainAppURL =
  (typeof process !== 'undefined' && process.env.MAIN_APP_INTERNAL_URL) ??
  config.urls.datacamp;

export const getMainAppApiClient = createClient(`${mainAppURL}/api`);

// Campus API
const campusApiURL =
  (typeof process !== 'undefined' && process.env.CAMPUS_API_INTERNAL_URL) ??
  config.urls.campusApi;

export const getCampusApiClient = createClient(`${campusApiURL}/api`);

// Teach
const teachClientURL =
  (typeof process !== 'undefined' && process.env.TEACH_INTERNAL_URL) ??
  config.urls.teach;

export const getTeachClient = createClient(`${teachClientURL}/api`);

// IMB
const imbClientURL =
  (typeof process !== 'undefined' && process.env.IMB_INTERNAL_URL) ??
  config.urls.imb;

export const getImbClient = createClient(imbClientURL);
